import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

const DEFAULT_DATE_FORMAT = 'L';
const DATE_DISPLAY_FORMAT = 'dddd, MMMM D';

const formatMeridiem = (formatted: string) =>
  formatted.replace(/AM$/, 'a.m.').replace(/PM$/, 'p.m.');

export const formatDateFromIso = (localStartTimeIso: string) =>
  dayjs(localStartTimeIso).format('ddd, MMM D');

export const getDateAndTimeFromIso = (startTime: string) => ({
  date: formatDateFromIso(startTime),
  time: formatMeridiem(dayjs(startTime, 'YYYY-MM-DDTHH:mm:ss').format('h:mm A'))
});

export const formatTimeFromIso = (timeIso: string) =>
  formatMeridiem(dayjs(timeIso, 'YYYY-MM-DDTHH:mm:ss').format('h:mm A'));

export const formatTimeSlotForDisplay = (date: string, time: string): string => {
  const formattedDate = dayjs(date).format('ddd, MMM DD');
  return `${formattedDate} at ${time}`;
};

export const normalizeDate = (date: string | Date) => {
  return dayjs(date);
};

export const parseDate = (date: string) => {
  return normalizeDate(date).toDate();
};

export const formatDateShort = (date: string | Date) => {
  return normalizeDate(date).format(DEFAULT_DATE_FORMAT);
};

export const formatDateDisplay = (date: string) => {
  return normalizeDate(date).format(DATE_DISPLAY_FORMAT);
};

export const formatDateForTimeHeader = (date: string) => {
  const d = normalizeDate(date);
  return `${d.format('ddd')}., ${d.format('MMM')}. ${d.format('D')}`;
};

export const isSameDay = (first: string | Date, second: string | Date) => {
  return normalizeDate(first).isSame(second, 'day');
};
